export default {
	cookie_expires: 10 * 365
}